import { Form, Input, Select, DatePicker, Space, Button } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import { useEffect } from "react";
import dayjs from "dayjs";
const { RangePicker } = DatePicker;

export default function FilterBar({ form }) {
  const handleReset = () => {
    form.setFieldsValue({
      status: ["unpaid", "partiallyPaid"], // 多选一定是数组
    });
  };

  return (
    <Form
      form={form}
      layout="inline"
      style={{ marginBottom: 16 }}
      initialValues={{
        status: ["unpaid", "partiallyPaid"], // 多选一定是数组
      }}
    >
      <Form.Item name="keyword">
        <Input placeholder="输入房号..." allowClear />
      </Form.Item>

      <Form.Item name="status">
        <Select
          mode="multiple"
          allowClear
          placeholder="状态"
          style={{ minWidth: 180 }}
          options={[
            { value: "unpaid", text: "未支付" },
            { value: "paid", text: "已支付" },
            { value: "partiallyPaid", text: "部分支付" },
            { value: "cancelled", text: "已取消" },
          ]}
        />
      </Form.Item>

      {/* 操作按钮 */}
      <Form.Item>
        <Space>
          <Button onClick={handleReset} icon={<ReloadOutlined />}>
            重置
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
}
